module.exports = __webpack_public_path__ + "a1cc59a5e6ea17b82c3cf29d334c82d7.svg";